import { render, staticRenderFns } from "./ClassroomStudent.vue?vue&type=template&id=d3834fe2"
import script from "./ClassroomStudent.vue?vue&type=script&lang=js"
export * from "./ClassroomStudent.vue?vue&type=script&lang=js"
import style0 from "./ClassroomStudent.vue?vue&type=style&index=0&id=d3834fe2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports